module.exports = __webpack_public_path__ + "img/logo.f3cfd95a.png";